export default __webpack_public_path__ + "static/media/guest-info-v2.076e9f51.svg";